/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RecoveryCashOnDeliveryCreateRequest } from '../../models/recovery-cash-on-delivery-create-request';
import { RecoveryCashOnDeliveryResponse } from '../../models/recovery-cash-on-delivery-response';

export interface PostFeV1RecoveryCods$Plain$Params {

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;

/**
 * Unique identifier for tracing the request across services
 */
  'X-Correlation-Id'?: string;
  
    /**
     * Recovery COD creation data.
     */
    body?: RecoveryCashOnDeliveryCreateRequest
}

export function postFeV1RecoveryCods$Plain(http: HttpClient, rootUrl: string, params?: PostFeV1RecoveryCods$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<RecoveryCashOnDeliveryResponse>> {
  const rb = new RequestBuilder(rootUrl, postFeV1RecoveryCods$Plain.PATH, 'post');
  if (params) {
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.header('X-Correlation-Id', params['X-Correlation-Id'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RecoveryCashOnDeliveryResponse>;
    })
  );
}

postFeV1RecoveryCods$Plain.PATH = '/v1/recovery-cods';
